/**
 * tsx文件太大了，以后有权限相关的方法都写在这里
 */

import { ROLES } from "../user-management/user-util";

const LEVEL = [
    [ROLES.USER, ROLES.APP_USER],
    [ROLES.USER, ROLES.APP_USER, ROLES.NAMESPACE],
    [ROLES.USER, ROLES.APP_USER, ROLES.NAMESPACE, ROLES.WORKSPACE_OWNER],
    [ROLES.USER, ROLES.APP_USER, ROLES.NAMESPACE, ROLES.WORKSPACE_OWNER, ROLES.CLUSTER_OWNER],
    [ROLES.USER, ROLES.APP_USER, ROLES.NAMESPACE, ROLES.WORKSPACE_OWNER, ROLES.CLUSTER_OWNER, ROLES.CLUSTER_ADMIN],
    [ROLES.USER, ROLES.APP_USER, ROLES.NAMESPACE, ROLES.WORKSPACE_OWNER, ROLES.CLUSTER_OWNER, ROLES.CLUSTER_ADMIN, ROLES.GLOBAL_ADMIN],
];

const compare_role = (item: any, record: any) => {
    let flag = true;
    for (let key in item) {
        if (key !== 'key' && record?.hasOwnProperty(key) && item[key] !== record[key]) {
            flag = false;
            break;
        }
    }
    return flag;
}

const disable_del_role = (info: any, record: any) => {
    const operator_roles = info.roles;
    const dc = record.datacenter;
    const ct = record.cluster;
    const ws = record.workspace;
    const role = record.roleName;
    let flag = true;
    if (info.role === ROLES.GLOBAL_ADMIN) {
        flag = false;
    } else {
        loop: for (let item of operator_roles) {
            const my_role = item.roleName;
            switch (my_role) {
                case ROLES.GLOBAL_ADMIN:
                    if (LEVEL[4].includes(role) && dc === item.datacenter) {
                        flag = false;
                        break loop;
                    }
                    break;
                case ROLES.CLUSTER_ADMIN:
                    if (LEVEL[3].includes(role) && ct === item.cluster) {
                        flag = false;
                        break loop;
                    }
                    break;
                case ROLES.CLUSTER_OWNER:
                    if (LEVEL[2].includes(role) && ct === item.cluster) {
                        flag = false;
                        break loop;
                    }
                    break;
                case ROLES.WORKSPACE_OWNER:
                    if (LEVEL[1].includes(role) && ws === item.workspace) {
                        flag = false;
                        break loop;
                    }
                    break;
                default:
                    break;
            }
        }
    }

    return flag;
}

const disable_del_roles = (info: any, records: any) => {
    let flag = false;

    for (let item of records) {
        flag = disable_del_role(info, item);
        if (flag) {
            break;
        }
    }
    return flag;
}

export { compare_role, disable_del_role, disable_del_roles }